import React, { useState } from 'react';
import './ModalConfirmarExclusao.css';

const ModalConfirmarExclusao = ({ isOpen, onClose, onConfirmDelete, albumName }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleDelete = async () => {
    try {
      setIsLoading(true);
      await onConfirmDelete();
      onClose();
    } catch (err) {
      console.error('Erro ao deletar álbum:', err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Escape') {
      onClose();
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div
      className="modal-backdrop"
      onClick={handleBackdropClick}
      onKeyPress={handleKeyPress}
    >
      <div className="modal-card modal-confirmacao">
        <h2 className="modal-titulo">Excluir álbum?</h2>

        <div className="modal-body">
          <div className="confirmacao-ícone">🗑️</div>
          <p className="confirmacao-mensagem">
            Tem certeza que deseja excluir <strong>"{albumName}"</strong>?
          </p>
          <p className="confirmacao-aviso">
            Essa ação não pode ser desfeita.
          </p>
        </div>

        <div className="modal-footer">
          <button
            className="btn-cancelar"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancelar
          </button>
          <button
            className="btn-excluir"
            onClick={handleDelete}
            disabled={isLoading}
          >
            {isLoading ? 'Excluindo...' : 'Excluir'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalConfirmarExclusao;
